var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 72,
    viewBox: "0 0 360 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_6",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 360,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H348C354.627 0 360 5.37258 360 12V72H0V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 -3.05176e-05H348C354.627 -3.05176e-05 360 5.37255 360 12V72H61V-3.05176e-05Z",
    fill: "#ED5A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 27.5L74 27V72L26.5 74.5L49.5 27.5Z",
    fill: "#ED5A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 -3.00002C77.2681 -0.304233 84.7681 -1.69582 83 0.999969L39.5028 71.1033C37.8707 74.0237 32.8701 74.0237 31.238 71.1033L10.5028 44.2936C8.73466 41.5978 12.0608 34.9348 13.8289 32.239C15.461 29.3186 21.8707 29.3186 23.5028 32.239L35.0028 49.2936L61.0028 5.2936C62.6349 2.37317 73.8679 -5.92046 75.5 -3.00002Z",
    fill: "#FCF4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 -4.00005C72.7681 -1.30426 80.2681 -6.69583 78.5 -4.00004L32 73C30.3679 75.9204 26.6321 74.9204 25 72L6.50275 41.2936C4.73463 38.5978 6.23182 36.1958 7.99994 33.5C9.63205 30.5796 17.8679 30.5796 19.5 33.5L29 50L59.5 -1.50004C61.1321 -4.42047 69.3679 -6.92049 71 -4.00005Z",
    fill: "#ED5A29"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmButton);
export default __webpack_public_path__ + "static/media/confirm_button.1758822b5185bbdcef34433bab06af01.svg";
export { ForwardRef as ReactComponent };